import { Avatar } from "@its-engineering-and-development/ui-foundation/components";
import type { ApprovalsView, ChargeApprovalItem } from "./dashboard-types";
import { DashboardCard, DASHBOARD_SUMMARY_CARD_CLASS } from "./dashboard-card";
import { DashboardCardSelect } from "./dashboard-card-select";
import { DashboardListRow } from "./dashboard-list-row";
import { DashboardScrollableList } from "./dashboard-scrollable-list";

const APPROVALS_VIEW_OPTIONS = [
    { id: "all", label: "View all" },
    { id: "submitted", label: "Submitted" },
    { id: "clarification", label: "Clarification" },
] as const;

const APPROVAL_AVATAR_CLASS = "shrink-0 !bg-[#6B7280]";
const APPROVAL_AVATAR_INITIALS_CLASS = "text-xs font-semibold leading-none text-white";

export interface ChargeApprovalsCardProps {
    items: ChargeApprovalItem[];
    view: ApprovalsView;
    onViewChange: (view: ApprovalsView) => void;
}

export function ChargeApprovalsCard({ items, view, onViewChange }: ChargeApprovalsCardProps) {
    return (
        <DashboardCard
            title="Approvals"
            className={DASHBOARD_SUMMARY_CARD_CLASS}
            filter={
                <DashboardCardSelect
                    label="Approvals filter"
                    selectedKey={view}
                    options={[...APPROVALS_VIEW_OPTIONS]}
                    onSelectionChange={(key) => onViewChange(key as ApprovalsView)}
                />
            }
        >
            <DashboardScrollableList>
                <ul className="space-y-2">
                    {items.map((item) => (
                        <DashboardListRow key={item.id}>
                            <Avatar
                                size="sm"
                                alt={item.name}
                                contrastBorder={false}
                                className={APPROVAL_AVATAR_CLASS}
                                placeholder={<span className={APPROVAL_AVATAR_INITIALS_CLASS}>{item.initials}</span>}
                            />
                            <div className="min-w-0">
                                <p className="truncate text-sm font-semibold text-gray-900">{item.name}</p>
                                <p className="text-xs text-gray-500">{item.statusLabel}</p>
                            </div>
                        </DashboardListRow>
                    ))}
                </ul>
            </DashboardScrollableList>
        </DashboardCard>
    );
}
